import prodConfig from './config.production.json';
import devConfig from './config.dev.json';
import localConfig from './config.local.json';

let config = {};

// get environment-specific configurations
if (process.env.REACT_APP_ENVIRO === "development") {
    console.log('Using dev config');
    config = devConfig;
} else if (process.env.REACT_APP_ENVIRO === "local") {
    console.log('Using local config');
    config = localConfig;
} else {
    console.log('Using prod config');
    config = prodConfig;
}

// set up the build number
config.buildNumber = "1.0.4";

// the guid that must be passed to the register page in order for the link to work
config.registrationGuid = "5bc1704c-48c0-41d5-88d5-36ab6c015b0b";

// the URLs to redirect users to following user login attempts
config.loginSuccessUrl = "/dashboard"
config.loginFailUrl = '/?s=unableToLogin'

// the guids representing each user role
config.roles = [
    {
        "roleID": "572180F3-3F48-4523-B547-2B134FCB05CF",
        "role": "superadmin"
    },
    {
        "roleID": "8B5574CD-25E9-4344-A417-C893C0168B64",
        "role": "admin"
    },
    {
        "roleID": "2272D1CF-AA55-472F-BEE0-FD4DBBB707AB",
        "role": "user"
    }
]

// the menu structure visible to each user type
const navLinks = {
    dealer: [
        { icon: "dashboard2", label: "m0006", link: "/dashboard", active: true },
        {
            icon: "suggestions2", label: "m0464", submenu: [

                { icon: "All", label: "m0438", link: "/suggested-order/type/0" },
                { icon: "GM", label: "m0436", link: "/suggested-order/type/1" },
                { icon: "PA", label: "m0437", link: "/suggested-order/type/2" }
            ]
        },
        //change out suggestions2 for new icon
        { icon: "booking", label: "m0596", link: "/booking-returns" },
        { icon: "part2", label: "m0295", link: "/parts" },
        { icon: "report2", label: "m0379", link: "/reports" },
        //{
        //    icon: "settings2", label: "m0279", submenu: [
        //        { icon: "PS", label: "m0298", link: "/settings/part-seasons" },
        //        { icon: "PE", label: "m0276", link: "/settings/part-exceptions" }
        //    ]
        //},
        { icon: "support2", label: "m0460", link: '/support' }
    ],
    dealergroup: [
        { icon: "dashboard2", label: "m0006", link: "/dashboard", active: true },
        {
            icon: "suggestions2", label: "m0464", submenu: [

                { icon: "All", label: "m0438", link: "/suggested-order/type/0" },
                { icon: "GM", label: "m0436", link: "/suggested-order/type/1" },
                { icon: "PA", label: "m0437", link: "/suggested-order/type/2" }
            ]
        },
        { icon: "booking", label: "m0596", link: "/booking-returns" },
        { icon: "part2", label: "m0295", link: "/parts" },
        { icon: "report2", label: "m0379", link: "/reports" },
        {
            icon: "settings2", label: "m0279", submenu: [
                { icon: "RG", label: "m0465", link: "/settings/report-groups" }
                //{ icon: "PS", label: "m0298", link: "/settings/part-seasons" }
                //{ icon: "PE", label: "m0276", link: "/settings/part-exceptions" }
            ]
        },
        { icon: "support2", label: "m0460", link: "/support" }
    ],
    'manufacturer.region': [
        { icon: "dashboard2", label: "m0006", link: "/dashboard", active: true },
        { icon: "part2", label: "m0295", link: "/parts" },
        { icon: "report2", label: "m0379", link: "/reports" },
        {
            icon: "settings2", label: "m0279", submenu: [
                { icon: "RG", label: "m0465", link: "/settings/report-groups" }
                //{ icon: "PS", label: "m0298", link: "/settings/part-seasons" }
                //{ icon: "PE", label: "m0276", link: "/settings/part-exceptions" }
            ]
        },
        { icon: "support2", label: "m0460", link: "/support" }
    ],
    manufacturer: [
        { icon: "dashboard2", label: "m0006", link: "/dashboard", active: true },
        //{ icon: "inventory", label: "m0207", link: "/inventory-shaping" },
        { icon: "part2", label: "m0295", link: "/parts" },
        { icon: "report2", label: "m0379", link: "/reports" },
        {
            icon: "settings2", label: "m0279", submenu: [
                { icon: "RG", label: "m0465", link: "/settings/report-groups" }
                //{ icon: "PS", label: "m0298", link: "/settings/part-seasons" }
                //{ icon: "PE", label: "m0276", link: "/settings/part-exceptions" }
            ]
        },
        { icon: "support2", label: "m0460", link: "/support" }
    ]
}

//!DBTRANS! @m0006@ Dashboard !DEVNOTE! Sidebar Title
//!DBTRANS! @m0463@ Dashboard !DEVNOTE! Sidebar Title
//!DBTRANS! @m0464@ Suggested order !DEVNOTE! Sidebar Title
//!DBTRANS! @m0465@ Report groups !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0438@ All Parts !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0436@ GM !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0437@ P&A !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0279@ Settings !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0298@ Part Seasons !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0276@ Part Exceptions !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0460@ Support !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0295@ Part Lookup !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0379@ Reports !DEVNOTE! Sidebar Title 
//!DBTRANS! @m0207@ Inventory Shaping !DEVNOTE! Sidebar Title
//!DBTRANS! @m0596@ Booking & Returns !DEVNOTE! Sidebar Title

// what filters to use for each report.
// need to see what filter choices are available? Look inside ReportsDataFilters.js
// need to see what reports are available? Check out the SOMWEB.Reports table, and SOMWEB.OrgTypeReports for a mapping of which org types can see which reports.
const reportFilters = {
    "dealer": {
        "top-seller-items": [
            { "filter": "DateFilter", "required": true },
            { "filter": "PartGroupFilter" },
            { "filter": "VendorFilter" }
        ],
        "suggested-order-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true, "hasEmptyOption": false, "required": true },
            { "filter": "OrderTypeFilter" }
        ],
        "slow-moving-items": [
            { "filter": "VendorFilter" },
            { "filter": "PartGroupFilter" }
        ],
        "aged-inventory": [
            { "filter": "VendorFilter" },
            { "filter": "PartGroupFilter" }
        ],
        "obsolete-inventory": [
            { "filter": "VendorFilter" },
            { "filter": "PartGroupFilter" }
        ],
        "inventory-mix-history": [
            { "filter": "VendorFilter", "majorVendor": true }
        ],
        "part-sales-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true },
            { "filter": "PartGroupFilter" },
            { "filter": "PartNumberFilter" }
        ],
        "som-usage-stats": [
            { "filter": "DateFilter", "required": true },
            { "filter": "CountryFilter" },
            { "filter": "OrgTypeFilter" },
            { "filter": "OrgFilter" }
        ],
        "som-adoption": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true },
            { "filter": "CountryFilter" },
            { "filter": "OrgFilter" }
        ],
        "parts-booking-tool": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true, "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter", "hasEmptyOption": true },
        ],
        "parts-booking-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true, "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter", "hasEmptyOption": true },
        ],
        "parts-return": [
            { "filter": "VendorFilter", "majorVendor": true, "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter", "hasEmptyOption": true },
            { "filter": "PartCategoryFilter", "hasEmptyOption": true },
            { "filter": "AgeFilter" },
            { "filter": "CostFilter", "mode": "min" },
            { "filter": "ValueFilter", "mode": "max" },
        ],
    },

    "dealergroup": {
        "top-seller-items": [
            { "filter": "DateFilter", "required": true },
            { "filter": "PartGroupFilter" },
            { "filter": "VendorFilter" },
            { "filter": "DealershipFilter", "filterType": "both" }
        ],
        "top-performers": [
            { "filter": "DealershipFilter", "filterType": "reportGroup" },
            { "filter": "MonthYearFilter", "hasEmptyOption": false, "required": true }
        ],
        "top-overstocking": [
            { "filter": "DealershipFilter", "filterType": "reportGroup" }
        ],
        "slow-moving-items": [
            { "filter": "DealershipFilter", "filterType": "both" },
            { "filter": "PartGroupFilter" },
            { "filter": "VendorFilter" }
        ],
        "suggested-order-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "VendorFilter", "majorVendor": true, "hasEmptyOption": false, "required": true },
            { "filter": "OrderTypeFilter" }
        ],
        "aged-inventory": [
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "VendorFilter" },
            { "filter": "PartGroupFilter" }
        ],
        "obsolete-inventory": [
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "VendorFilter" },
            { "filter": "PartGroupFilter" }
        ],
        "inventory-mix-comparison": [
            { "filter": "MonthYearFilter", "hasEmptyOption": false, "required": true },
            { "filter": "VendorFilter", "majorVendor": true, "dealerGroupOnly": true },
            { "filter": "DealershipFilter", "filterType": "reportGroup" }
        ],
        "inventory-mix-history": [
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "VendorFilter", "majorVendor": true }
        ],
        "part-sales-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "VendorFilter", "majorVendor": true },
            { "filter": "PartGroupFilter" },
            { "filter": "PartNumberFilter" }
        ],
        "som-usage-stats": [
            { "filter": "DateFilter", "required": true },
            { "filter": "CountryFilter" },
            { "filter": "OrgTypeFilter" },
            { "filter": "OrgFilter" }
        ],
        "som-adoption": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true },
            { "filter": "CountryFilter" },
            { "filter": "OrgFilter" }
        ],
        "parts-booking-tool": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true, "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter", "hasEmptyOption": true },
        ],
        "parts-booking-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true, "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter", "hasEmptyOption": true },
        ],
        "parts-return": [
            { "filter": "VendorFilter", "majorVendor": true, "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter", "hasEmptyOption": true },
            { "filter": "PartCategoryFilter", "hasEmptyOption": true },
            { "filter": "AgeFilter" },
            { "filter": "CostFilter", "mode": "min" },
            { "filter": "ValueFilter", "mode": "max" },
        ],
    },

    "manufacturer.region": {
        "top-seller-items": [
            { "filter": "DateFilter", "required": true },
            { "filter": "PartGroupFilter" },
            { "filter": "DealershipFilter", "filterType": "both" }
        ],
        "top-performers": [
            { "filter": "DealershipFilter", "filterType": "reportGroup" },
            { "filter": "MonthYearFilter", "hasEmptyOption": false, "required": true }
        ],
        "top-overstocking": [
            { "filter": "DealershipFilter", "filterType": "reportGroup" }
        ],
        "suggested-order-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "OrderTypeFilter" }
        ],
        "slow-moving-items": [
            { "filter": "DealershipFilter", "filterType": "both" },
            { "filter": "PartGroupFilter" }
        ],
        "aged-inventory": [
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter" }
        ],
        "obsolete-inventory": [
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter" }
        ],
        "inventory-mix-comparison": [
            { "filter": "MonthYearFilter", "hasEmptyOption": false, "required": true },
            { "filter": "DealershipFilter", "filterType": "reportGroup" }
        ],
        "inventory-mix-history": [
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true }
        ],
        "part-sales-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter" },
            { "filter": "PartNumberFilter" }
        ],
        "som-usage-stats": [
            { "filter": "DateFilter", "required": true },
            { "filter": "CountryFilter" },
            { "filter": "OrgTypeFilter" },
            { "filter": "OrgFilter" }
        ],
        "som-adoption": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true },
            { "filter": "CountryFilter" },
            { "filter": "OrgFilter" }
        ]
    },

    "manufacturer": {
        "top-seller-items": [
            { "filter": "DateFilter", "required": true },
            { "filter": "PartGroupFilter" },
            { "filter": "DealershipFilter", "filterType": "both" }
        ],
        "top-performers": [
            { "filter": "DealershipFilter", "filterType": "reportGroup" },
            { "filter": "MonthYearFilter", "hasEmptyOption": false, "required": true }
        ],
        "top-overstocking": [
            { "filter": "DealershipFilter", "filterType": "reportGroup" }
        ],
        "suggested-order-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "OrderTypeFilter" }
        ],
        "slow-moving-items": [
            { "filter": "DealershipFilter", "filterType": "both" },
            { "filter": "PartGroupFilter" }
        ],
        "aged-inventory": [
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter" }
        ],
        "obsolete-inventory": [
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter" }
        ],
        "inventory-mix-comparison": [
            { "filter": "MonthYearFilter", "hasEmptyOption": false, "required": true },
            { "filter": "DealershipFilter", "filterType": "reportGroup" }
        ],
        "inventory-mix-history": [
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true }
        ],
        "part-sales-history": [
            { "filter": "DateFilter", "required": true },
            { "filter": "DealershipFilter", "filterType": "dealership", "hasEmptyOption": false, "required": true },
            { "filter": "PartGroupFilter" },
            { "filter": "PartNumberFilter" }
        ],
        "som-usage-stats": [
            { "filter": "DateFilter", "required": true },
            { "filter": "CountryFilter" },
            { "filter": "OrgTypeFilter" },
            { "filter": "OrgFilter" }
        ],
        "som-adoption": [
            { "filter": "DateFilter", "required": true },
            { "filter": "VendorFilter", "majorVendor": true },
            { "filter": "CountryFilter" },
            { "filter": "OrgFilter" }
        ]
    }
};

// a list of descriptions for each report
const reportDescriptions = {
    "top-seller-items": "m0511",
    "top-performers": "m0512",
    "top-overstocking": "m0513",
    "suggested-order-history": "m0514",
    "slow-moving-items": "m0515",
    "aged-inventory": "m0516",
    "obsolete-inventory": "m0517",
    "inventory-mix-comparison": "m0518",
    "inventory-mix-history": "m0519",
    "part-sales-history": "m0520",
    "som-usage-stats": "m0521",
    "som-adoption": "m0522",
    "parts-booking-tool": "m0595",
    "parts-booking-history": "m0598",
    "parts-return": "m0619",

}

config = {
    ...config,
    navLinks: { ...navLinks },
    reportFilters: { ...reportFilters },
    reportDescriptions: { ...reportDescriptions }
}

export default config;



// WEBPACK FOOTER //
// ./src/config/config.js